(ns manage.adset-preview-panel.db.notifications
  (:require [re-frame.core :as rf]))

(rf/reg-event-fx :adset-preview.notifications/show-short
  (fn [_ [_ id notification ms]]
    {:dispatch [:adset-preview.notifications/show id notification]
     :dispatch-later [{:ms (if (nat-int? ms) ms 3e3)
                       :dispatch [:adset-preview.notifications/hide id]}]}))

(rf/reg-event-db :adset-preview.notifications/show
  (fn [db [_ id notification]]
    (assoc-in db [:adset-preview.notifications id] notification)))

(rf/reg-event-db :adset-preview.notifications/hide
  (fn [db [_ id]]
    (update-in db [:adset-preview.notifications] dissoc id)))

(rf/reg-sub :adset-preview.notifications/notifications
  (fn [db _]
    (get db :adset-preview.notifications)))
